export function isDavTemplatesEnabled(): boolean {
  const raw = import.meta.env.VITE_ENABLE_DAVTEMPLATES;
  if (raw == null) return false;
  const v = String(raw).trim().toLowerCase();
  return v === "1" || v === "true" || v === "yes" || v === "on";
}

/**
 * Feature flag for Motion Capture mode in the animation panel.
 * Allows capturing keyframes from reference clips to create custom presets.
 * Enable with VITE_MOTION_CAPTURE=1 in .env
 */
export function isMotionCaptureEnabled(): boolean {
  const raw = import.meta.env.VITE_MOTION_CAPTURE;
  if (raw == null) return false;
  const v = String(raw).trim().toLowerCase();
  return v === "1" || v === "true" || v === "yes" || v === "on";
}

/**
 * Feature flag for TwinBoost Digital Twin system.
 * Main kill switch for the entire TwinBoost feature.
 * Enable with VITE_TWINBOOST_ENABLED=1 in .env
 */
export function isTwinBoostEnabled(): boolean {
  const raw = import.meta.env.VITE_TWINBOOST_ENABLED;
  if (raw == null) return false;
  const v = String(raw).trim().toLowerCase();
  return v === "1" || v === "true" || v === "yes" || v === "on";
}

/**
 * Feature flag for TwinBoost closed beta access.
 * When enabled, only beta users can access TwinBoost.
 * Enable with VITE_TWINBOOST_BETA=1 in .env
 */
export function isTwinBoostBetaEnabled(): boolean {
  const raw = import.meta.env.VITE_TWINBOOST_BETA;
  if (raw == null) return false;
  const v = String(raw).trim().toLowerCase();
  return v === "1" || v === "true" || v === "yes" || v === "on";
}

/**
 * Feature flag for TwinBoost Ultra tier (Anti-Gravity provider).
 * Premium highest-realism tier with limited availability.
 * Enable with VITE_TWINBOOST_ULTRA=1 in .env
 */
export function isTwinBoostUltraEnabled(): boolean {
  const raw = import.meta.env.VITE_TWINBOOST_ULTRA;
  if (raw == null) return false;
  const v = String(raw).trim().toLowerCase();
  return v === "1" || v === "true" || v === "yes" || v === "on";
}
